export default {
  status: '',
  token: localStorage.getItem('token') || '',
  user : {},
  canConnectToSocket: false,
  userSocketConnection: null,
  integratorSocketConnection: null
}
